export default __webpack_public_path__ + "static/media/lock-privacy.7d1ff4b8.svg";